angular.module('tgaAdmin').controller('InstructorController', [
  '$scope',
  '$state',
  'gameService',
  function ($scope, $state, gameService) {
    $scope.data = {
      gameId: $state.params.id || null,
      gameTypes: gameService.getGameTypes().filter((gameType) => gameType.instructor === true),
    };

    $scope.viewmodel = {
      games: [],
    };

    $scope.initialize = function () {};

    $scope.actions = {
      loadGames(tableState) {
        $scope.loading = true;

        const params = {
          is_instructor_game_mode: true,
          paginate: true,
          page: Math.floor(tableState.pagination.start / tableState.pagination.number) + 1,
          limit: tableState.pagination.number,
          sort: tableState.sort.predicate,
          order: tableState.sort.reverse ? 'desc' : 'asc',
        };

        if (tableState?.search?.predicateObject) {
          Object.keys(tableState.search.predicateObject).forEach((key) => {
            params[key] = tableState.search.predicateObject[key];
          });
        }

        gameService.getGames(params).then((games) => {
          $scope.viewmodel.games = games.items || games;

          if (tableState) {
            tableState.pagination.numberOfPages = Math.ceil(games.total / tableState.pagination.number);
            tableState.pagination.totalItemCount = games.total;
          }
        }).finally(() => {
          $scope.loading = false;
        });
      },
    };

    $scope.initialize();
  },
]);
